import React from 'react'
import {FormattedMessage, useIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import {useLocale, useQuery, useSEO} from '../../hocs/hooks'
import {IPost} from '../../../../models/Post'
import {IPostDetail} from '../../../../resolvers/post'
import BullHorn from '../../../assets/icons/media/BullHorn.svg'
import {titlesMessages} from '../../../config/commonMessages'
import TextPager from '../../common/TextPager'
import Breadcrumb from '../../containers/Breadcrumb'
import BreadcrumbHome from '../../containers/BreadcrumbHome'
import {IRouteComponentProps} from '../../containers/DataResolver'
import { getMaxPage, getPostCanonicalUrl } from '../../../helpers/post'
import {PostThumbnailList} from '../../post/PostThumbnail'
import {PostThumbnailListSp} from '../../post/PostThumbnailSp'
import SideBar from '../../post/SideBar'
import styles from './LatestPosts.scss'
import { defaultMediaPagesSize } from '../../../config/constants'
import NotFound from '../../common/NotFound'

const LatestPosts = ({resolvedData: {
  posts,
  total,
  rankPosts,
  newPosts,
  rankKeywords,
  postCategories
}}: IRouteComponentProps<{
  posts: ReadonlyArray<IPost>,
  total: number,
} & IPostDetail>) => {
  const locale = useLocale()
  const intl = useIntl()
  const {page} = useQuery()
  useSEO({title: !page
    ? intl.formatMessage(titlesMessages.latestPosts)
    : intl.formatMessage(titlesMessages.latestPostsWithPage, {page: page}),
    canonicalUrl: getPostCanonicalUrl(locale,'latest',page , true)
  })

  const maxPage = total && getMaxPage(total, defaultMediaPagesSize)
  if (parseInt(page) && maxPage && parseInt(page) > maxPage) {
    return <NotFound />
  }
  return <>
    <Breadcrumb>
      <BreadcrumbHome/>
      <Link to={`/${locale}/media/`}>
        VANLIFE JAPAN TOP
      </Link>
      <FormattedMessage id="post.postsList" defaultMessage="List of posts"/>
    </Breadcrumb>
    <div className="container pt-md-4 mt-md-3 pb-md-5 mb-md-5">
      <div className={['row mx-0 mb-md-3', styles.outline].join(' ')}>
        <div className="col-md-8 px-0">
          <div>
            <div className="d-flex align-items-center pb-md-3 mb-md-5 py-3 my-3 pt-md-0 mt-md-0">
              <BullHorn className={['fa font-size-2x mr-2', styles.icon].join(' ')}/>
              <h1 className={['font-weight-bold mb-0', styles.title].join(' ')}>
                <FormattedMessage id="post.allLatestPosts" defaultMessage="See all latest posts"/>
              </h1>
            </div>
            <div className={[styles.spBackground, 'd-md-none d-block pb-3'].join(' ')}/>
            <div className="mb-3 pb-3 mb-md-0 pb-md-0">
              <div className="d-none d-md-flex row ml-0 pb-3">
                <PostThumbnailList posts={posts}/>
              </div>
              <div className="d-md-none d-flex row mx-0 justify-content-between my-3 pt-3">
                <PostThumbnailListSp posts={posts}/>
              </div>
              <div className="d-flex justify-content-center mr-md-4">
              <TextPager total={total}/>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4 px-0 pl-md-5">
          <SideBar rankKeywords={rankKeywords} newPosts={newPosts} rankPosts={rankPosts} postCategories={postCategories}/>
        </div>
      </div>
    </div>
  </>
}
LatestPosts.displayName = 'LatestPosts'
export default LatestPosts
